import { useState, useEffect } from 'react';

interface LoadingStateProps {
  isPendingCart: boolean;
  isPendingDelete: boolean;
}

export default function useLoadingState({ isPendingCart, isPendingDelete }: LoadingStateProps) {
  const [loading, setLoading] = useState<boolean>(false);
  
  useEffect(() => {
    setLoading(isPendingCart || isPendingDelete);
  }, [isPendingCart, isPendingDelete]);
  
  return { loading };
}
